import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  ACCOUNTING_ENV,
} from "../../config/micros-env.tokens";
import { EnvMicroAccounting } from "../../config/env.micro.accounting";
import { WalletOperationsSummaryResponse } from "../../../domain/models/accounting/wallet-operations.model";
import { WalletOperationsPort } from "../../../app/ports/accounting/wallet-operations.port";
import { isWalletOperationsSummaryResponse } from "../../validators/accounting/wallet-operations.validator";
import { WalletOperationsSseClient } from "./wallet-operations-sse.client";

@Injectable()
export class WalletOperationsHttpAdapter implements WalletOperationsPort {
  private static readonly SUMMARY_PATH = "/api/v1/wallet-operations/summary/stream";

  constructor(
    @Inject(ACCOUNTING_ENV) private readonly env: EnvMicroAccounting,
    private readonly sseClient: WalletOperationsSseClient,
  ) {}

  getSummary(companyId: number): Observable<WalletOperationsSummaryResponse> {
    const baseUrl = `${this.env.host}${this.env.apiBasePath}`.replace(/\/$/, "");
    const url = `${baseUrl}${WalletOperationsHttpAdapter.SUMMARY_PATH}?idCompany=${encodeURIComponent(companyId)}`;

    return this.sseClient.connect<WalletOperationsSummaryResponse>(
      { url },
      (data) => {
        try {
          const response = JSON.parse(data) as unknown;
          return isWalletOperationsSummaryResponse(response) ? response : null;
        } catch {
          return null;
        }
      },
    );
  }
}
